var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "borrow" }, [
    _c("form", [
      _c("h1", { staticClass: "f-weight__500 text-center font-small title" }, [
        _vm._v("借款协议")
      ]),
      _c("div", { staticClass: "cel cel-right" }, [
        _c("div", { staticClass: "cel-content" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.contractNo,
                expression: "form.contractNo"
              }
            ],
            staticClass: "width-mini",
            attrs: { type: "text", name: "contractNo" },
            domProps: { value: _vm.form.contractNo },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "contractNo", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "cel-content f-weight__600 font-small" }, [
          _vm._v("编号：")
        ])
      ]),
      _c("div", { staticClass: "all-indent" }, [
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [
            _vm._v("甲方（借款人）：")
          ]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpName,
                  expression: "form.fpName"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpName" },
              domProps: { value: _vm.form.fpName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("住所：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpAddress,
                  expression: "form.fpAddress"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpAddress" },
              domProps: { value: _vm.form.fpAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpAddress", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [
            _vm._v("乙方（出借人）：")
          ]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spName,
                  expression: "form.spName"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spName" },
              domProps: { value: _vm.form.spName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("住所：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spAddress,
                  expression: "form.spAddress"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spAddress" },
              domProps: { value: _vm.form.spAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spAddress", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("p", [
        _vm._v(
          "\n      甲方因扩大经营，向出借方借款。经双方友好协商，特订立本合同，以昭信守。"
        ),
        _c("br"),
        _vm._v("\n      第一条 借款用途"),
        _c("br"),
        _vm._v("\n      本合同所借款项用于"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.moneyUse,
              expression: "form.moneyUse"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "moneyUse" },
          domProps: { value: _vm.form.moneyUse },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "moneyUse", $event.target.value)
            }
          }
        }),
        _vm._v("。"),
        _c("br"),
        _vm._v("\n      第二条 借款金额及账户信息"),
        _c("br"),
        _vm._v("\n      借款金额为：人民币"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.money,
              expression: "form.money"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "money" },
          domProps: { value: _vm.form.money },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "money", $event.target.value)
            }
          }
        }),
        _vm._v("元（大写 "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.moneyZh,
              expression: "form.moneyZh"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "moneyZh" },
          domProps: { value: _vm.form.moneyZh },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "moneyZh", $event.target.value)
            }
          }
        }),
        _vm._v("元整），实际借款额以转账金额为准。（账户信息如下：）\n      "),
        _c("table", { staticClass: "table-systemp" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("户名")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankEntity,
                      expression: "form.bankEntity"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankEntity" },
                  domProps: { value: _vm.form.bankEntity },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankEntity", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("tr", [
              _c("td", [_vm._v("银行账号")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankNo,
                      expression: "form.bankNo"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankNo" },
                  domProps: { value: _vm.form.bankNo },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankNo", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("tr", [
              _c("td", [_vm._v("开户银行")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankName,
                      expression: "form.bankName"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankName" },
                  domProps: { value: _vm.form.bankName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankName", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        ]),
        _vm._v("\n      第三条 借款期限"),
        _c("br"),
        _vm._v("\n      借款日期为"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.borrowStart,
              expression: "form.borrowStart"
            }
          ],
          attrs: { type: "text", name: "borrowStart" },
          domProps: { value: _vm.form.borrowStart },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "borrowStart", $event.target.value)
            }
          }
        }),
        _vm._v("起至"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.borrowEnd,
              expression: "form.borrowEnd"
            }
          ],
          attrs: { type: "text", name: "borrowEnd" },
          domProps: { value: _vm.form.borrowEnd },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "borrowEnd", $event.target.value)
            }
          }
        }),
        _vm._v("。"),
        _c("br"),
        _vm._v("\n      第四条 借款偿还及利息支付"),
        _c("br"),
        _vm._v("\n      (一)借款人按本合同规定到期一次性偿还全部本金。"),
        _c("br"),
        _vm._v("\n      (二)本合同为无利息借款。\n      "),
        _c("table", { staticClass: "table-systemp" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("户名")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankEntityB,
                      expression: "form.bankEntityB"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankEntityB" },
                  domProps: { value: _vm.form.bankEntityB },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankEntityB", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("tr", [
              _c("td", [_vm._v("银行账号")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankNoB,
                      expression: "form.bankNoB"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankNoB" },
                  domProps: { value: _vm.form.bankNoB },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankNoB", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("tr", [
              _c("td", [_vm._v("开户银行")]),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bankNameB,
                      expression: "form.bankNameB"
                    }
                  ],
                  staticClass: "width-medium text-left",
                  attrs: { type: "text", name: "bankNameB" },
                  domProps: { value: _vm.form.bankNameB },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "bankNameB", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        ]),
        _vm._v("\n      第五条 借贷双方权利义务："),
        _c("br"),
        _vm._v(
          "\n      1、 借款方必须按照借款合同规定的用途使用借款，不得挪作他用，不得用借款进行违法活动。"
        ),
        _c("br"),
        _vm._v("\n      2、借款方应当按照合同约定期限按时还款。"),
        _c("br"),
        _vm._v("\n      (二)出借方义务"),
        _c("br"),
        _vm._v("\n      1、出借方应当按期足额将款项支付到借款人帐户。"),
        _c("br"),
        _vm._v(
          "\n      2、出借方应当对借款人相关的债务、财务、经营及各类商业信息保密。"
        ),
        _c("br"),
        _vm._v("\n      第六条 违约责任："),
        _c("br"),
        _vm._v(
          "\n      1、如到期未还款，则应从还款到期之日起次日开始支付每月2%的利息，直至还清之日为止。"
        ),
        _c("br"),
        _vm._v(
          "\n      2、本合同正式签订后，任何一方不履行或不完全履行本协议约定条款的，即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失。"
        ),
        _c("br"),
        _vm._v("\n      3、任何一方违约时，守约方有权要求违约方继续履行本协议"),
        _c("br"),
        _vm._v("\n      第七条 协议的变更或解除："),
        _c("br"),
        _vm._v(
          "\n      1、 借款人需要延长借款期限的，应在借款到期日前三日内向出借人提出书面申请，征得其同意。"
        ),
        _c("br"),
        _vm._v(
          "\n      2、借款方使用借款造成损失浪费或利用借款合同进行违法活动的，贷款方应追回贷款本息，有关单位对直接责任人应追究行政和经济责任。情节严重的，由司法机关追究刑事责任。"
        ),
        _c("br"),
        _vm._v(
          "\n      3、 由于行政主管部门决定关、停、并、转或者由于不可抗力的意外事故致使合同无法履行时，公司应进行清算。借款人可以向出借方申请，变更或解除合同，并免除承担违约责任。"
        ),
        _c("br"),
        _vm._v(
          "\n      4、 本合同的变更，必须经双方共同协商，并订立书面变更协议。"
        ),
        _c("br"),
        _vm._v("\n      第八条 解决合同纠纷的方式："),
        _c("br"),
        _vm._v(
          "\n      执行本合同发生争议，由当事人双方协商解决。协商不成，任何一方有权向公司注册地所在人民法院提起诉讼。"
        ),
        _c("br"),
        _vm._v("\n      第九条 其他"),
        _c("br"),
        _vm._v(
          "\n      本合同正本一式两份，双方各执一份，两份具有同等法律效力。"
        ),
        _c("br")
      ]),
      _vm._m(0),
      _vm._m(1),
      _c("div", { staticClass: "cel" }, [
        _c("div", { staticClass: "cel-content" }, [_vm._v("电话：")]),
        _c("div", { staticClass: "cel-content__full" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.fpMobile,
                expression: "form.fpMobile"
              }
            ],
            staticClass: "width-full",
            attrs: { type: "text", name: "fpMobile" },
            domProps: { value: _vm.form.fpMobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "fpMobile", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "cel" }, [
        _c("div", { staticClass: "cel-content" }, [_vm._v("日期：")]),
        _c("div", { staticClass: "cel-content__full" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.signDateA,
                expression: "form.signDateA"
              }
            ],
            staticClass: "width-full",
            attrs: { type: "text", name: "signDateA" },
            domProps: { value: _vm.form.signDateA },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "signDateA", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "cel" }, [
        _c("div", { staticClass: "cel-content" }, [_vm._v("签订地点：")]),
        _c("div", { staticClass: "cel-content__full" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.signAddressA,
                expression: "form.signAddressA"
              }
            ],
            staticClass: "width-full",
            attrs: { type: "text", name: "signAddressA" },
            domProps: { value: _vm.form.signAddressA },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "signAddressA", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticStyle: { "margin-bottom": "100px" } }, [
        _vm._m(2),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("电话：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spMobile,
                  expression: "form.spMobile"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spMobile" },
              domProps: { value: _vm.form.spMobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spMobile", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("日期：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.signDateB,
                  expression: "form.signDateB"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "signDateB" },
              domProps: { value: _vm.form.signDateB },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "signDateB", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("签订地点：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.signAddressB,
                  expression: "form.signAddressB"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "signAddressB" },
              domProps: { value: _vm.form.signAddressB },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "signAddressB", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("（以下为签署页，无正文）")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cel" }, [
      _c("div", { staticClass: "cel-content" }, [_vm._v("借款人(盖章)：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cel" }, [
      _c("div", { staticClass: "cel-content" }, [_vm._v("出借人(盖章)：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f218aa7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f218aa7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/borrow.vue
// module id = da5V
// module chunks = 1 57